import lscache from 'lscache';

const MONTH = 60 * 24 * 30;

export interface ActionFactory {
  setCurrency: (currency: string) => void;
}


function actionsFactory(dispatcher): ActionFactory {
  return {
    setCurrency(newCurrency) {
      dispatcher({ payload: { currency: newCurrency } });
      console.log('settings currency to ' + newCurrency);
      lscache.set('CURRENCY', newCurrency, MONTH);
    },
  }
}

export default actionsFactory;
